import React, { Children, PropTypes, PureComponent } from 'react';

export default class Separated extends PureComponent {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    separator: PropTypes.node
  };

  static defaultProps = {
    separator: ', '
  };

  render() {
    const { children, separator, ...rest } = this.props;

    const numChildren = Children.count(children);

    return (
      <span {...rest}>
        {
          Children.map(
            children,
            (child, index) => {
              const separatorNode = (index < numChildren - 1) ?
                <span key="sep">{separator}</span> : null;

              return (
                <span key={index}>
                  <span>{child}{separatorNode}</span>
                </span>
              );
            }
          )
        }
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/Separated.jsx